module.exports = __webpack_public_path__ + "img/UlnarSplint-08.d814618d.svg";